export const GIT_COMMIT = '4ee0135c9564fca604b4644eb99c672f05a8dc45'
